import PropTypes from 'prop-types';
import { useMemo } from 'react';

// material-ui
import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';

// project import
import useConfig from 'hooks/useConfig';
import Palette from './palette';
import Typography from './typography';

import componentStyleOverrides from './compStyleOverride';
import customShadows from './shadows';
import { light } from '@mui/material/styles/createPalette';

export default function ThemeCustomization({ children }) {
    const { borderRadius, fontFamily, navType, outlinedFilled, presetColor, rtlLayout } = useConfig();

    const theme = useMemo(() => Palette(navType, presetColor), [navType, presetColor]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const themeTypography = useMemo(() => Typography(theme, borderRadius, fontFamily), [theme, borderRadius, fontFamily]);
    const themeCustomShadows = useMemo(() => customShadows(navType, theme), [navType, theme]);

    // const themeOptions = useMemo(
    //     () => ({
    //         direction: rtlLayout ? 'rtl' : 'ltr',
    //         palette: theme.palette,
    //         mixins: {
    //             toolbar: {
    //                 minHeight: '48px',
    //                 padding: '16px',
    //                 '@media (min-width: 600px)': {
    //                     minHeight: '48px'
    //                 }
    //             }
    //         },
    //         typography: themeTypography,
    //         customShadows: themeCustomShadows
    //     }),
    //     [rtlLayout, theme, themeCustomShadows, themeTypography]
    // );

    const themeOptions = useMemo(
        () => ({
            direction: rtlLayout ? 'rtl' : 'ltr',
            palette: {
                ...theme.palette,
                primary: {
                    ...theme.palette.primary,
                    main: '#1B357C',
                    dark: '#1B357C',
                    light: '#E7E7E7',
                    A100: '#2950BC',
                    A200: '#6D8BDF'
                },
                secondary: {
                    ...theme.palette.secondary,
                    main: '#1B357C',
                    dark: '#1B357C',
                    light: '#E7E7E7'
                },
                background: {
                    ...theme.palette.background,
                    // default: '#E7E7E7',
                    // paper: '#E7E7E7',
                    light: '#E7E7E7'
                },
                text: {
                    ...theme.palette.text
                    // primary: '#1B357C',
                    // secondary: '#1B357C'
                }
            },
            typography: themeTypography,
            customShadows: themeCustomShadows,
            mixins: {
                toolbar: {
                    minHeight: '48px',
                    padding: '16px',
                    '@media (min-width: 600px)': {
                        minHeight: '48px'
                    }
                },
                ...theme.mixins
            }
        }),
        [rtlLayout, theme, themeCustomShadows, themeTypography]
    );

    const themes = useMemo(() => {
        const t = createTheme(themeOptions);
        const components = componentStyleOverrides(t, borderRadius, outlinedFilled);
        return createTheme({
            ...themeOptions,
            components
        });
    }, [themeOptions, borderRadius, outlinedFilled]);

    return (
        <ThemeProvider theme={themes}>
            <StylesThemeProvider theme={{ ...themes }}>
                <CssBaseline />
                {children}
            </StylesThemeProvider>
        </ThemeProvider>
    );
}

ThemeCustomization.propTypes = {
    children: PropTypes.node
};
